import * as React from "react";
const SvgInfo = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", fill: "none", stroke: "currentColor", strokeWidth: 8, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M32,52v-28h-12M20,56h24M32,6v8" }));
export default SvgInfo;
